import React from 'react';

import {Box, Button, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

import {IconIllustration} from 'presentation/components';
import Icon from 'presentation/icons';
import {RatingStatusEnum} from 'domain/usecases';
import {translations} from 'presentation/translations-new';
import {Loading} from 'presentation/components/Loading/Loading';
import {ImageContainer, StyledDialog, StyledDialogHeader} from './styles';
import {useRatingModal} from '../../hooks/useRatingModals';
import {ErrorNotEvaluatingProps} from './types';

const {pleaseTryAgain, tryAgain, notPossibleAction} = translations['pt-br'].commons;
const {rateYourAttendance} = translations['pt-br'].privateFlow.fiveStarsRating;

export function ErrorNotEvaluating({ratingDetail}: ErrorNotEvaluatingProps) {
	const {handleRefuseToEvaluate, isSubmitting, ratingModal} = useRatingModal();

	const data = {
		cdatendimento: ratingDetail.keys.cdatendimento,
		cdusuario: ratingDetail.keys.cdusuario,
		tipo: ratingDetail.keys.tipo,
		status: RatingStatusEnum.NEVER_EVALUTE,
	};

	return (
		<StyledDialog open={ratingModal === 'error-refuse'}>
			<StyledDialogHeader>{rateYourAttendance}</StyledDialogHeader>
			<DialogContent>
				<ImageContainer>
					<IconIllustration variant="info" size="big" />
				</ImageContainer>
				<DialogTitle textAlign="center">{notPossibleAction}</DialogTitle>
				<DialogContentText textAlign="center" color="text.primary">
					{pleaseTryAgain}
				</DialogContentText>
			</DialogContent>
			<Box p={2}>
				<Button
					fullWidth
					size="large"
					variant="outlined"
					disabled={isSubmitting}
					onClick={() => handleRefuseToEvaluate(data)}
					endIcon={
						isSubmitting ? (
							<Loading size={20} color="inherit" />
						) : (
							<Icon name="reload" size={24} color="inherit" />
						)
					}>
					{tryAgain}
				</Button>
			</Box>
		</StyledDialog>
	);
}
